import React from "react";
import qs from "qs";
import Link from "gatsby-link";
import styled, { withTheme } from "styled-components";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import { connect as reduxConnect } from "react-redux";
import {
  updateSearchQuery,
  toggleSearchInput,
  setShowSearchInput,
  toggleMobileMenuOpen
} from "../../state";
import DefaultMenu from "./default";
import MobileMenu from "./mobile";

const mapStateToProps = state => {
  return {
    state: {
      searchQuery: state.searchQuery,
      showSearchInput: state.showSearchInput
    },
    mobileState: state.mobileMenu
  };
};

const mapDispatchToProps = (dispatch, props) => {
  const dispatchUpdateSearchQuery = query => {
    dispatch(updateSearchQuery(query));
  };
  return {
    updateSearchQuery: dispatchUpdateSearchQuery,
    onMount: () => {
      const { location } = props;
      if (location.pathname === "/zoek") {
        const { q: query } = qs.parse(props.location.search.replace("?", ""));
        dispatchUpdateSearchQuery(query);
        dispatch(setShowSearchInput(true));
      }
    },
    updateURL: query => {
      props.history.push({
        pathname: "/zoek",
        search: `?q=${query}`
      });
    },
    toggleSearch: () => {
      dispatch(toggleSearchInput());
    },
    hideSearch: () => {
      dispatch(setShowSearchInput(false));
    },
    toggleOpen: () => {
      dispatch(toggleMobileMenuOpen());
    }
  };
};

const Input = styled.input`
  border: none;
  color: ${({ theme }) => theme.colors.blue.hex};
  font-weight: normal;
  border-bottom: 1px solid black;
  text-decoration: none;
  background-color: transparent;
  // flex: 0.5;
  &:focus {
    outline: none;
  }
  width: 100%;
`;

const connect = compose(
  withRouter,
  reduxConnect(mapStateToProps, mapDispatchToProps)
);

const links = [
  {
    component: Link,
    props: {
      children: ["Home"],
      to: "/"
    }
  },
  {
    component: Link,
    props: {
      children: ["Projecten"],
      to: "/projecten"
    }
  },
  {
    component: Link,
    props: {
      children: ["Nieuws"],
      to: "/nieuws"
    }
  },
  {
    component: Link,
    props: {
      children: ["Over"],
      to: "/over"
    }
  }
];

const MenuContainer = withTheme(
  class extends React.Component {
    componentWillMount() {
      this.props.onMount();
    }

    render() {
      const {
        state,
        theme: { mobile },
        mobileState,
        toggleOpen,
        hideSearch,
        toggleSearch
      } = this.props;

      const defaultNavItems = [
        ...(mobile.isMobile && state.showSearchInput ? [] : links),
        {
          component: Link,
          props: {
            children: ["Zoek"],
            to: "/zoek",
            onClick: toggleSearch
          }
        }
      ];

      const navItems =
        (!mobile.isMobile && state.showSearchInput) ||
        (state.showSearchInput && mobile.isMobile && mobileState.open)
          ? defaultNavItems.concat({
              component: Input,
              props: {
                autoFocus: true,
                value: this.props.state.searchQuery,
                placeholder: "",
                onClick: () => null,
                onKeyPress: e => {
                  if (e.key === "Enter") {
                    toggleOpen();
                    setTimeout(() => {
                      hideSearch();
                    }, 1000);
                  }
                },
                onChange: e => {
                  const query = e.target.value;
                  this.props.updateSearchQuery(query);
                  this.props.updateURL(query);
                }
              }
            })
          : defaultNavItems;

      return mobile.isMobile ? (
        <MobileMenu
          {...mobile.menu.layoutProps}
          navItems={navItems.map(item => ({
            ...item,
            props: {
              ...item.props,
              onClick: item.props.onClick || toggleOpen
            }
          }))}
          toggleOpen={toggleOpen}
          state={mobileState}
        />
      ) : (
        <DefaultMenu
          navItems={navItems.map(item => ({
            ...item,
            props: {
              ...item.props,
              onClick: item.props.onClick || hideSearch
            }
          }))}
          toggleOpen={toggleOpen}
        />
      );
    }
  }
);

export default connect(MenuContainer);



// WEBPACK FOOTER //
// ./src/layouts/menu/menu.js